import { IMAGES_PATH } from 'themes'

export const warningImg = IMAGES_PATH('/alert-warning.svg')
export const warningImgYellow = IMAGES_PATH('/alert-warning-yellow.svg')
export const infoImg = IMAGES_PATH('/alert-info.svg')
export const errorImg = IMAGES_PATH('/alert-error.svg')

export const SeverityMap = {
    Warning: warningImg,
    Info: infoImg,
    Error: errorImg,
}
